import $ from 'jquery';

$('.js-toggle-expand-button').click(function() {
  $(this).parent('div').parent('div').toggleClass( "is-expand" );
});

setTimeout(() => {
  $('.js-toggle-expand-button').each(function() {
    const counter = $(this).parent('div').parent('div').find('table tr').not('.hidden').length;
    if(counter > 6){
      $(this).parent('div').removeAttr('hidden');
    }
  });
}, 500);